<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
     <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 class="h3 mb-0 text-gray-800">Welcome to CRCB Control Panel</h1>
            </div>

            <!-- Content Row -->
            <div class="row">
              <div class="col-xl-3 col-md-6 mb-4"  style="cursor:pointer;" v-on:click="GoMember" v-if="is_superuser" >
                <div class="card border-left-primary shadow h-100 py-2">
                  <div class="card-body">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">管理人員總數</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{member}}</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-user fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-md-6 mb-4"  style="cursor:pointer;" v-on:click="GoContact" v-if="permission.contact">
                <div class="card border-left-primary shadow h-100 py-2">
                  <div class="card-body">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">聯絡表單總數</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{contact}}</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-address-book fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-md-6 mb-4"  style="cursor:pointer;" v-on:click="GoContactEN" v-if="permission.contact_en">
                <div class="card border-left-primary shadow h-100 py-2">
                  <div class="card-body">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">英文聯絡表單總數</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{contact_en}}</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-address-book fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      member:0,
      contact:0,
      contact_en:0,
      is_superuser:false,
      permission:{
        banner:false,
        banner_en:false,
        activity:false,
        activity_en:false,
        category:false,
        category_en:false,
        contact:false,
        contact_en:false,
        faculty:false,
        faculty_en:false,
        news:false,
        news_en:false
      }
    }
  },
  mounted () {

    if (localStorage.getItem("is_superuser")){
      this.is_superuser = localStorage.getItem("is_superuser") === 'true' ? true : false;
      this.permission = JSON.parse(localStorage.getItem("user_data"));
    }
    
    this.GetMemberNum();
    this.GetContactNum();
    this.GetContactENNum();

  },
  methods: {
    GoMember() {
      this.$router.push({name: 'User'});
    }, 
    GoContact() {
      this.$router.push({name: 'Contact'});
    }, 
    GoContactEN() {
      this.$router.push({name: 'Contact_en'});
    },
    GetMemberNum() {
      db.collection("admin").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.member++;
          });
      });
    },
    GetContactNum() {
      db.collection("contact").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.contact++;
          });
      });
    },
    GetContactENNum() {
      db.collection("contact_en").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.contact_en++;
          });
      });
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/components/Home.vue